import React from "react";
import { Card, EmptyState } from "@jsq/ds/core";
import { cardWrapper } from "./style_vanilla.css";

export const ErrorPage = () => {
  return (
    <Card className={cardWrapper} padding="md">
      <EmptyState
        illustration="no-internet"
        title="The link has expired"
        description="You may close this tab"
        data-testid="illustration-error-page"
      />
    </Card>
  );
};
